
import * as type from "../mutation-types"
const state={
    token:window.localStorage.getItem("token") || "",
    SYSUser:window.localStorage.getItem("SYSUser") || "",
    menuList:window.localStorage.getItem('c_d_list') == 'undefined' ? [] : JSON.parse(window.localStorage.getItem('c_d_list'))
}
const getters={
    getToken:state=>state.token,
    getSYSUser:state=>state.SYSUser,
    getMenuList:state=>state.menuList,
}

const mutations={
    [type.USER_LOGIN_SUCCESS](state,response){
        state.token=response.return_token
        state.SYSUser=response.SYSUser
        state.menuList=response.menuList
    },
    [type.USER_OUT_LOGIN](state){
        state.token=null
        state.SYSUser=null
    }
}

const actions={
    onLogin({commit},response){
        commit(type.USER_LOGIN_SUCCESS,response)
        window.localStorage.setItem("token",response.return_token)
        window.localStorage.setItem("SYSUser",response.SYSUser)
        window.localStorage.setItem("c_d_list",JSON.stringify(response.menuList))
    },
    outLogin({commit}){
        commit(type.USER_OUT_LOGIN)
        window.localStorage.removeItem("token")
        window.localStorage.removeItem("SYSUser")
        window.localStorage.removeItem("c_d_list")
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}